import React, { useState, useMemo } from 'react'
import { Input, Spin, Button, Select, message, Modal, Checkbox } from 'antd'
import R from 'ramda'
import MultiCauseCodePropmt from '../../MultiCauseCode'

import { connect } from 'react-redux'

import { getExpandedKeys } from './Card97EditAntd'

import { getUnitCodeCauseCodeMapList, monthsMap, rowHeaderRender } from 'core'
import { saveCard97QuickFillMultiple } from 'api/pgads'

import { Grid, virtualizedGridRenderer } from '@integec/grid-tools'
import {
  unitHeader,
  unitIdHeader,
  utilityHeader,
} from 'core/HeaderColTypeProps'
import { intCol } from '@integec/grid-tools/lib/cols'
import { fixDescriptionValue } from '../../utils'

const QuickFillBKF = ({
  // CLIENT = 'INTEG',
  ampCodeMap,
  failCodeMap,
  targetInfo,
  visible,
  // unitCodeMap,
  dataList = [],
  utilityNameMap = {},
  unitNameMap = {},
  ...props
}) => {
  const [causeCodeChecked, setCauseCodeChecked] = useState(false)
  const [failCodeChecked, setFailCodeChecked] = useState(false)
  const [causeCodeText, setCauseCodeText] = useState()
  const [showCauseCodeDialog, setShowCauseCodeDialog] = useState(false)
  const [descriptionChecked, setDescriptionChecked] = useState(false)
  const [descriptionText, setDescrptionText] = useState('')
  const [failCodeSelect, setFailCodeSelect] = useState('')
  const [ampCodeSelect, setAmpCodeSelect] = useState('')

  const unitCodeCauseCodeMap = useMemo(
    _ => getUnitCodeCauseCodeMapList(props.causeCodeList || []),
    [props.causeCodeList]
  )

  const [causeCodeTreeVal, setCauseCodeTreeVal] = useState(
    getExpandedKeys(unitCodeCauseCodeMap)()
  )
  const saveQuickFillData = _ => {
    if (!(causeCodeChecked || failCodeChecked || descriptionChecked)) {
      message.warning('Please, Update data to save')
      return
    }
    if (
      failCodeChecked &&
      ampCodeSelect &&
      ampCodeSelect.trim().length > 0 &&
      ampCodeSelect.trim().length !== 2
    ) {
      setMsg('Amplification Code can only have two characters.')
    } else if (
      failCodeChecked &&
      failCodeSelect &&
      failCodeSelect.trim().length > 0 &&
      failCodeSelect.trim().length !== 4
    ) {
      setMsg('Fail Code can only have four characters.')
    }

    // const eventStart= dataSave.eventStart
    //         ? moment(dataSave.eventStart).format('MM/DD/YYYY HH:mm')
    //         : ''
    //       //          eventStartZone: dataSave.eventStartZone ? dataSave.eventStartZone : '',
    //       const eventEnd= dataSave.eventEnd
    //         ? moment(dataSave.eventEnd).format('MM/DD/YYYY HH:mm')
    //         : ''

    const showLockedEvents = events => {
      Modal.info({
        width: 1100,
        height: 400,
        title: (
          <div
            style={{
              display: 'grid',
              justifyContent: 'left',
              alignContent: 'center',
            }}
          >
            The following event(s) are locked. They cannot be modified.
          </div>
        ),
        content: (
          <div style={{ height: 350, width: 1000 }}>
            <Grid
              data={events}
              headers={[
                {
                  ...utilityHeader,
                  dataFormatter: ({ value }) => utilityNameMap[value] || value,
                  sortIndexGetter: ({ rowData }) =>
                    utilityNameMap[rowData.utility] || rowData.utility,
                },
                {
                  ...unitHeader,
                  dataFormatter: ({ value }) => unitNameMap[value] || value,
                  sortIndexGetter: ({ rowData }) =>
                    unitNameMap[rowData.unit] || rowData.unit,
                },
                intCol({
                  ident: 'year',
                  display: 'Year',
                  isKey: true,
                  width: 50,
                }),
                intCol({
                  ident: 'eventNum',
                  display: 'Event Number',
                  isKey: true,
                  width: 100,
                }),
              ]}
              render={virtualizedGridRenderer({
                height: 350,
                width: 1000,
                headerRowHeight: 30,
                rowHeaderRender,
              })}
            />
          </div>
        ),
        okText: 'OK',
        onOk: close => {
          close()
          props.retrieveData({})
          props.onCancel(false)
        },
      })
    }

    const showStaticsDialog = statics => {
      Modal.info({
        width: 1100,
        height: 400,
        title: (
          <div
            style={{
              display: 'grid',
              justifyContent: 'left',
              alignContent: 'center',
            }}
          >
            Please be reminded to execute a level 2 check for the unit and
            months affected by this update.
          </div>
        ),
        content: (
          <div style={{ height: 350, width: 1000 }}>
            <Grid
              data={statics}
              headers={[
                {
                  ...utilityHeader,
                  dataFormatter: ({ value }) => utilityNameMap[value] || value,
                  sortIndexGetter: ({ rowData }) =>
                    utilityNameMap[rowData.utility] || rowData.utility,
                },
                {
                  ...unitIdHeader,
                  dataFormatter: ({ value }) => unitNameMap[value] || value,
                  sortIndexGetter: ({ rowData }) =>
                    unitNameMap[rowData.unitId] || rowData.unit,
                },
                intCol({
                  ident: 'year',
                  display: 'Year',
                  isKey: true,
                  width: 50,
                }),
                intCol({
                  ident: 'month',
                  display: 'Month',
                  isKey: true,
                  width: 100,
                  dataFormatter: ({ value }) => monthsMap[value] || value,
                }),
              ]}
              render={virtualizedGridRenderer({
                height: 350,
                width: 1000,
                headerRowHeight: 30,
                rowHeaderRender,
              })}
            />
          </div>
        ),
        okText: 'OK',
        onOk: close => {
          close()
          props.retrieveData({})
          props.onCancel(false)
        },
      })
    }

    const saveData = {
      hasCause: causeCodeChecked,
      hasAmp: failCodeChecked,
      hasDesc: descriptionChecked,

      newCause: causeCodeText,
      newAmp: (failCodeSelect || '    ') + ' ' + (ampCodeSelect || '  '),

      newDesc: (descriptionText || '').trim(),
      eventData: dataList,
    }
    props.setSpinning(true)
    saveCard97QuickFillMultiple(targetInfo)(saveData).fork(
      e => props.setError(e, props.onCancel),
      data => {
        props.setSpinning(false)

        const { lockStatus = {}, staticsData = [] } = data

        if (Object.keys(lockStatus).length > 0) {
          const lockedEvents = Object.keys(lockStatus)
            .filter(f => lockStatus[f] !== 'U')
            .map(f => lockStatus[f])
          if (lockedEvents.length > 0) showLockedEvents(lockedEvents)
        } else if (staticsData.length > 0) {
          showStaticsDialog(staticsData)
        } else {
          // success
          props.retrieveData({})
          props.onCancel(false)
          message.info('Data saved.')
        }

        // if (data.length > 0) {
        //   props.setErrorSaveData(data)
        //   props.setErrorPropmt(true)
        // } else {
        //   message.info('Data saved Successfully')
        //   props.onCancel(false)
        //   props.retrieveData({})
        // }
      }
    )
  }

  const failAmpCodeOption = R.compose(
    R.map(([key, text]) => ({ key, text, value: key })),
    R.sortBy(([_, text]) => text.toLowerCase()),
    R.toPairs
  )

  const onCauseCodeDialogClose = (causeCodeKeyValues, causeCodeValues) => {
    setShowCauseCodeDialog(false)
    setCauseCodeText(
      causeCodeValues
        ? causeCodeValues.length > 0
          ? causeCodeValues[0].causeCode
          : ''
        : ''
    )
  }
  const setMsg = m => {
    message.error(m)
  }

  return (
    <Modal
      title="Quick Fill"
      visible={visible}
      onOk={saveQuickFillData}
      onCancel={props.onCancel}
      bodyStyle={{
        display: 'grid',
      }}
      width={900}
      height={400}
      style={{ top: 10 }}
      okText="Save"
      spinning={props.spinning}
      confirmLoading={props.spinning}
    >
      <Spin spinning={props.spinning}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '130px 200px max-content',
            gridGap: '10px',
          }}
        >
          <Checkbox
            checked={causeCodeChecked}
            onChange={e => {
              setCauseCodeChecked(e.target.checked)
            }}
          >
            Cause Code
          </Checkbox>
          <Input
            disabled={!causeCodeChecked}
            value={causeCodeText}
            onChange={e => {
              setCauseCodeText(e.target.value)
              setCauseCodeTreeVal(getExpandedKeys(unitCodeCauseCodeMap)())
            }}
          />
          <Button
            style={{ minWidth: '150px', maxWidth: '150px' }}
            disabled={!causeCodeChecked}
            onClick={_ => setShowCauseCodeDialog(true)}
          >
            Select
          </Button>
          <Checkbox
            checked={failCodeChecked}
            onChange={e => setFailCodeChecked(e.target.checked)}
          >
            Fail Code
          </Checkbox>

          <Select
            style={{ gridColumnEnd: 'span 2', minWidth: '700px' }}
            placeholder="Fail Code"
            onChange={value => {
              if (value === 'NONE') {
                setFailCodeSelect()
              } else {
                setFailCodeSelect(value)
              }
            }}
            value={failCodeSelect}
            disabled={!failCodeChecked}
            showSearch
          >
            <Select.Option key="NONE" value="NONE">
              NONE
            </Select.Option>
            {failAmpCodeOption(failCodeMap).map(({ key, value, text }) => (
              <Select.Option value={value} key={key}>
                {text}
              </Select.Option>
            ))}
          </Select>

          <div>Amplification Code</div>
          <Select
            style={{ gridColumnEnd: 'span 2' }}
            placeholder="Amplification Code"
            onChange={value => {
              if (value === 'NONE') {
                setAmpCodeSelect()
              } else {
                setAmpCodeSelect(value)
              }
            }}
            value={ampCodeSelect}
            disabled={!failCodeChecked}
            showSearch
          >
            <Select.Option key="NONE" value="NONE">
              NONE
            </Select.Option>
            {failAmpCodeOption(ampCodeMap).map(({ key, value, text }) => (
              <Select.Option value={value} key={key}>
                {text}
              </Select.Option>
            ))}
          </Select>
          <Checkbox
            style={{ gridColumnEnd: 'span 3' }}
            checked={descriptionChecked}
            onChange={e => setDescriptionChecked(e.target.checked)}
          >
            Event Description
          </Checkbox>
          <Input.TextArea
            disabled={!descriptionChecked}
            style={{ gridColumnEnd: 'span 3' }}
            value={descriptionText}
            rows={4}
            maxLength={300}
            onChange={e => {
              let value = e.target.value

              value = fixDescriptionValue(value)

              setDescrptionText(value)
            }}
          />

          {showCauseCodeDialog && (
            <MultiCauseCodePropmt
              causeCodeList={props.causeCodeList}
              key="card97Quickfillprompt"
              // style={{ ...inlineStyle }}
              // checkable={false}
              visibleDialog={showCauseCodeDialog}
              onDialogClose={onCauseCodeDialogClose}
              onCancelAction={_ => setShowCauseCodeDialog(false)}
              // defaultExpandedKeys={causeCode ? causeCode.selectedKeys : []}
              defaultExpandedKeys={causeCodeTreeVal.causeCodeKeyValues || []}
              selectedKeys={causeCodeTreeVal.causeCodeKeyValues || []}
              selectedValues={causeCodeTreeVal.causeCodeValues || []}
              unitCodes={[]}
              multiple={false}
              checkable={false}
              selectable
            />
          )}
        </div>
      </Spin>
    </Modal>
  )
}

const mapStateToProps = _ => ({})

export default connect(mapStateToProps)(QuickFillBKF)
